module.exports = __webpack_public_path__ + "media/components/helpcenter/InsightsHelp/MapInsight-91b4662e200cdcfcea7da7c6277c887a.jpg";